/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  const $toggle = $('[data-toggle]')

  $toggle.on('click', function(event) {
    const $this = $(this)
    const id = $this.data('toggle')
    const $target = $('[data-toggle-target="' + id + '"]')

    event.preventDefault()

    $this.toggleClass('open')
    $target.toggleClass('open')

    // We also want to modify the header for theme control
    if (id === 'menu' || id === 'search') {
      const $header = $('.header')
      const $theme = $header.data('theme') || 'dark'

      if ($theme === 'dark') {
        if ($target.hasClass('open')) {
          $header.removeClass('color-black')
          $header.addClass('color-white menu-open')
        } else {
          $header.removeClass('color-white menu-open')
          $header.addClass('color-black')
        }
      }
    }
  })
}
